module.exports = __webpack_public_path__ + "static/media/2030101000.bdac9b28.jpg";